module.exports = __webpack_public_path__ + "img/04uni-doll.1e7ab8e0.png";